<template>
    <div>
        <h1>Playtest:</h1>
        <br/>Players should avoid reading this section as discovery is one of the best parts of Akashic Paths.
        <br/>In the following section is two playtests, a short run and long run. The shorter one is a bit easier and is recommended for players trying to learn the game for the first time, but the true challenge of Akashic Paths is the long run. This playtest is assuming you are using roll20, but Akashic Paths can be played on any table top, real or virtual. 
        <br/><br/>
        <h2>Short Run:</h2>
        <h3>Setting up the Journey Selection:</h3>
        <p
        >Setup a journey select like this:
        </p>
        <v-img :src="require('../../assets/Playtest_Journey_Select.jpg')"  contain height="480px"/>
        <h3>Reading Playtest Maps</h3>
        <p>Each map has marked all treasure locations, monsters and their spawns, areas of interest, which includes things like interactables and traps, and terrain of importance, and the long maps have their room numbers marked. In all maps a "S", "M", and "L" all signify gold piles, of sizes small, medium, and large, respectively. If it is marked a with a number that means it has additional notes for it in the treasure section. C signifies a cursed chest, which will spawn a monster before the treasure can be claimed. Due to possible visibility issues each map may use slightly different colors, check the color code at the beginning to see what means what. At the top of each section are links to download each map, both the annotated version, and the clean version used. </p>
        <v-expansion-panels style="z-index:0">
           <v-expansion-panel v-for="(name, index) in nameArray" :key="name">
            <v-expansion-panel-header>
              {{name}}
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <desert-tomb v-if="index == 0" @downloadImg="downloadURI"/>
              <drakes-lair v-if="index == 1" @downloadImg="downloadURI"/>
              <mages-dungeon v-if="index == 2" @downloadImg="downloadURI"/>
              <desert-ruin v-if="index == 3" @downloadImg="downloadURI"/>
              <plane-of-fire v-if="index == 4" @downloadImg="downloadURI"/>
              <earth-shrine v-if="index == 5" @downloadImg="downloadURI"/>
              <pharaohs-tomb v-if="index == 6" @downloadImg="downloadURI"/>
              <throne-of-heaven v-if="index == 7" @downloadImg="downloadURI"/>
              <fey-court v-if="index == 8" @downloadImg="downloadURI"/>
              <ancient-prison v-if="index == 9" @downloadImg="downloadURI"/>
              <astral-realm v-if="index == 10" @downloadImg="downloadURI"/>
              <beasts-lair v-if="index == 11" @downloadImg="downloadURI"/>
             </v-expansion-panel-content>
          </v-expansion-panel>          
        </v-expansion-panels> 
        <h3>Credits:</h3>I'd like to give a special thanks to those who produced the maps i used for the playtest, they are all free online, but i'd like to give a link to each of their patreons/website in case you'd like to support the great content they make too:
        <h4><a href="https://www.czepeku.com/" target="_blank">Czepeku:</a> </h4>For Ancient Prison, Beast's Lair, Fey Court, Pharoah's Tomb, and Throne of Heaven
        <h4><a href="https://www.patreon.com/neutralparty" target="_blank">Neutral Party:</a> </h4>For Astral Realm, Desert Ruin, and Plane of fire
        <h4><a href="https://www.patreon.com/mikwewa" target="_blank">Mikwewa: </a></h4>For Desert Tomb
        <h4><a href="https://www.patreon.com/tychmaps" target="_blank">Tych Maps:</a> </h4>For Mage's Dungeon
        <h4>Unknown: </h4>Earth Shrine. If you know who made this map please let me know so i can properly credit and link them! 
        <br/><br/>
        If any of you have any problem with me using these maps and linking to them please email me and I will take them down.
        
    </div>
</template>
<script>
import {
  VImg,
  VExpansionPanels,
  VExpansionPanel,
  VExpansionPanelHeader,
  VExpansionPanelContent,

} from "vuetify/lib";
import DesertTomb from './playTestMaps/desertTomb';
import MagesDungeon from "./playTestMaps/magesDungeon"
import PlaneOfFire from './playTestMaps/planeOfFire';
import EarthShrine from './playTestMaps/earthShrine';
import ThroneOfHeaven from './playTestMaps/throneOfHeaven'
import DesertRuin from './playTestMaps/desertRuin';
import PharaohsTomb from './playTestMaps/pharaohsTomb';
import BeastsLair from './playTestMaps/beastsLair';
import FeyCourt from './playTestMaps/feyCourt';
import AstralRealm from './playTestMaps/astralRealm';
import AncientPrison from './playTestMaps/ancientPrison';
import DrakesLair from './playTestMaps/drakesLair';
export default {
  components: {    
    VImg,
    VExpansionPanels,
    VExpansionPanel,
    VExpansionPanelHeader,
    VExpansionPanelContent,
    MagesDungeon,
    PlaneOfFire,
    EarthShrine,
    ThroneOfHeaven,
    DesertTomb,
    DesertRuin,
    PharaohsTomb,
    BeastsLair,
    FeyCourt,
    AstralRealm,
    AncientPrison,
    DrakesLair,
  },

  data(){   
    return{
      nameArray: ["Desert Tomb", "Drake's Lair","Mage's Dungeon", "Desert Ruin", "Plane Of Fire", "Earth Shrine", "Pharaoh's Tomb", "Throne Of Heaven", "Fey Court", "Ancient Prison", "Astral Realm", "Beast's Lair"]
    }
  },
  methods:{
    downloadURI(imgName) {
      var imgFullURL = document.getElementById(imgName).src;
      var link = document.createElement("a");
      link.download = imgName;
      link.href = imgFullURL;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
    }
  }
}
</script>
